import React from "react";
import StatusTable from "./StatusTable";
import highRisk from "../../../src/assets/images/high-priority.png"
import middleRisk from "../../../src/assets/images/middle-priority.png"
import lowRisk from "../../../src/assets/images/low-priority.png"
import normal from "../../../src/assets/images/normal-priority.png"
import "./StatusTable.css";

export default function RiskIndicatorsTable() {
  const riskIndicatorState = {
    columns: [
      { title: "Κωδικός", field: "riskIndicatorId", type: "numeric" },
      { title: "Περιγραφή", field: "riskIndicatorStatus" },
      { title: "Εικονίδιο", field: "riskIndicatorIcon" },
    ],
    data: [
      {
        riskIndicatorId: 1,
        riskIndicatorStatus: "Υψηλός",
        riskIndicatorIcon: (
          <img
            src={highRisk}
            alt="high-risk"
          />
        ),
      },
      {
        riskIndicatorId: 2,
        riskIndicatorStatus: "Μέτριος",
        riskIndicatorIcon: (
          <img
            src={middleRisk}
            alt="middle-risk"
          />
        ),
      },
      {
        riskIndicatorId: 3,
        riskIndicatorStatus: "Χαμηλός",
        riskIndicatorIcon: (
          <img
            src={lowRisk}
            alt="low-risk"
          />
        ),
      },
      {
        riskIndicatorId: 4,
        riskIndicatorStatus: "Φυσιολογικός",
        riskIndicatorIcon: (
          <img
            src={normal}
            alt="normal"
          />

        ),
      },
    ],
  };

  return (
    <StatusTable
      title="Δείκτες Κινδύνων"
      columns={riskIndicatorState.columns}
      data={riskIndicatorState.data}
    />
  );
}
